import { useProperty, useTranslation } from '@eti/providers';
import { useRef } from 'react';
import { useProductSnowplowTracking } from '../../custom-hooks/useProductSnowplowTracking';
import ProductLayout from '../../common/main-layout/ProductLayout';
import { useIllustration } from '../../common/utils/useIllustration';
import { CANCEL_FOR_ANY_REASON } from '../../products';
import { getProduct } from '../../single-choice/utils/singleChoiceTransformer';
import { getModal, getPriceProps, getReadMoreLabel, getSingleChoiceProps, getUpsellProps } from '../../common/utils/productCardProps';
import getTranslatedTexts from '../../common/text-resolvers/utils/getTranslatedTexts';
import { useLinksAccessibility } from '../../custom-hooks/useLinkAccessibility';
import { jsx as _jsx } from "react/jsx-runtime";
const {
  name: PRODUCT_NAME,
  id: PRODUCT_ID
} = CANCEL_FOR_ANY_REASON;
const generalTexts = {
  additionalInformation: 'cancelForAnyReasonAdditionalSalesText',
  persuasionContent: 'cancelForAnyReasonPersuasionContent',
  readMoreContent: 'cancelForAnyReasonReadMoreModalContent',
  description: 'cancelForAnyReasonAbstract',
  title: 'cancelForAnyReasonTitle',
  upSell: 'cancelForAnyReasonUpSell'
};
const MainCancelForAnyReason = _ref => {
  var _order$persuasion$isE, _order$persuasion;
  let {
    className,
    form,
    isSelected,
    order,
    productPosition,
    layoutType
  } = _ref;
  const {
    t,
    nonDebugT
  } = useTranslation();
  const {
    p
  } = useProperty();
  const illustrationUrl = useIllustration(PRODUCT_NAME);
  const translation = getTranslatedTexts(generalTexts, t);
  const rootElement = useRef(null);
  const {
    additionalInformation,
    description,
    readMoreContent,
    title
  } = translation;
  useProductSnowplowTracking(PRODUCT_NAME, {
    rootElement,
    productPosition
  });
  useLinksAccessibility({
    targetElement: rootElement,
    productTitle: title
  });
  const product = getProduct(PRODUCT_ID, order, 'none');
  if (!product) {
    return null;
  }
  const {
    priceRaw
  } = product;
  const {
    upSellObject,
    isUpsellHighlight = false,
    shouldDisplayUpsell = false
  } = getUpsellProps(translation.upSell);
  const {
    priceLabel,
    price,
    priceSuffix
  } = getPriceProps(t, isSelected, product);
  const extraProps = getSingleChoiceProps(t, p, nonDebugT);
  const productCardModal = getModal((_order$persuasion$isE = (_order$persuasion = order.persuasion) === null || _order$persuasion === void 0 ? void 0 : _order$persuasion.isEnabled) !== null && _order$persuasion$isE !== void 0 ? _order$persuasion$isE : false, '', translation.persuasionContent);
  const readMoreButtonLabel = getReadMoreLabel(t);
  const productData = {
    additionalInformation,
    extraProps,
    className,
    description,
    form,
    illustrationUrl,
    isHighlighted: isUpsellHighlight,
    isSelected,
    layoutType,
    price,
    priceLabel,
    priceRaw,
    priceSuffix,
    productCardModal,
    productId: PRODUCT_ID,
    productName: PRODUCT_NAME,
    productPosition,
    readMoreButtonLabel,
    readMoreContent,
    shouldDisplayUpsell,
    title,
    travelers: order.travelers,
    upSell: upSellObject
  };
  return /*#__PURE__*/_jsx(ProductLayout, {
    productData: productData,
    ref: rootElement
  });
};
export default MainCancelForAnyReason;
//# sourceMappingURL=MainCancelForAnyReason.js.map